import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Cachets = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.89 82.96">
  <G fill={color}>
    <Path d="M25.41,42.27c-11.06-2.63-22.21,4.23-24.84,15.29-1.28,5.36-.39,10.89,2.5,15.59,2.89,4.69,7.43,7.98,12.79,9.25,1.6.38,3.2.56,4.78.56,9.33,0,17.81-6.39,20.07-15.85,1.28-5.36.39-10.89-2.5-15.59-2.89-4.69-7.43-7.98-12.79-9.25ZM15.81,70.85c-.58.53-1.3.79-2.03.79-.81,0-1.62-.33-2.21-.97-2.77-3.02-3.86-7.2-2.91-11.18.38-1.61,2-2.61,3.61-2.22,1.61.38,2.61,2,2.22,3.61-.49,2.04.07,4.19,1.5,5.74,1.12,1.22,1.04,3.12-.18,4.24ZM20.95,56.03c-1.1-.06-2.2.18-3.19.68-.44.22-.91.33-1.37.33-1.09,0-2.14-.6-2.67-1.63-.76-1.47-.17-3.28,1.3-4.04,1.93-.99,4.09-1.44,6.24-1.34,1.65.09,2.92,1.5,2.84,3.15-.09,1.65-1.51,2.93-3.15,2.84Z"/>
    <Path d="M43.04.57c-5.36-1.27-10.89-.39-15.59,2.5-4.69,2.89-7.98,7.43-9.25,12.79-1.28,5.36-.39,10.9,2.5,15.59,2.89,4.69,7.43,7.98,12.79,9.25,1.6.38,3.21.57,4.82.57,3.77,0,7.48-1.04,10.77-3.07,4.69-2.89,7.98-7.43,9.25-12.79,2.63-11.06-4.23-22.21-15.29-24.84ZM33.44,29.15c-.58.53-1.3.79-2.03.79-.81,0-1.62-.33-2.21-.97-2.77-3.02-3.86-7.2-2.91-11.18.38-1.61,2-2.61,3.61-2.22,1.61.38,2.61,2,2.22,3.61-.49,2.04.07,4.19,1.5,5.74,1.12,1.22,1.04,3.12-.18,4.24ZM38.58,14.33c-1.11-.06-2.21.18-3.19.68-.44.22-.9.33-1.36.33-1.09,0-2.14-.6-2.67-1.63-.75-1.47-.17-3.28,1.3-4.04,1.93-.99,4.08-1.45,6.24-1.33,1.65.09,2.93,1.5,2.84,3.15-.09,1.65-1.5,2.92-3.15,2.84Z"/>
  </G>
</Svg>
);
};

export default Cachets;
